var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g3, _g4, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g5, _path25, _path26, _path27, _path28, _path29, _path30, _g6, _path31, _path32, _path33, _path34, _path35, _path36, _g7, _path37, _path38, _path39, _path40, _path41, _path42, _g8, _g9, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g10, _path55, _path56, _path57, _path58, _path59, _path60, _g11, _path61, _path62, _path63, _path64, _path65, _path66, _g12, _g13, _path67, _path68, _path69, _path70, _path71, _path72;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 209,
    viewBox: "0 0 430 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.744 99.2147L112.377 114.418L50.1387 78.3102L77.4582 63.1069L138.744 99.2147Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0977 100.24L85.3955 105.023L104.98 93.6603L96.3842 88.8765L77.0977 100.24Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0977 125.503L85.3955 130.287L104.98 118.926L96.3842 114.142L77.0977 125.503Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1465 125.503L85.4422 130.287L105.026 118.926L96.4308 114.142L77.1465 125.503Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3965 105.024V130.288",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3086 88.8765V114.142L104.972 118.917V93.6516",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0977 100.156V125.42",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.8086 88.9068L69.1065 93.6906L88.6886 82.3298L80.0929 77.5459L60.8086 88.9068Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8086 114.172L69.1065 118.956L88.6886 107.593L80.0929 102.809L60.8086 114.172Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8574 114.172L69.1531 118.956L88.7374 107.593L80.1418 102.809L60.8574 114.172Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1074 93.6909V118.957",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0176 77.5459V102.81L88.6811 107.585V82.321",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8086 88.8235V114.089",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.291 78.1487L51.5867 82.9326L71.171 71.5695L62.5754 66.7856L43.291 78.1487Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.291 103.412L51.5867 108.196L71.171 96.8351L62.5754 92.0513L43.291 103.412Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3359 103.412L51.6338 108.196L71.2181 96.8351L62.6203 92.0513L43.3359 103.412Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5859 82.9326V108.196",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 66.7856V92.0515L71.1613 96.8266V71.5629",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.291 78.0654V103.329",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 66.8162L35.2979 71.6L54.8822 60.2392L46.2865 55.4553L27 66.8162Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 92.0821L35.2979 96.8659L54.8822 85.5051L46.2865 80.7212L27 92.0821Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0488 92.0818L35.3467 96.8657L54.9288 85.5048L46.3332 80.7209L27.0488 92.0818Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2988 71.5999V96.8657",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2109 55.4553V80.7211L54.8723 85.4963V60.2304",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 66.7332V91.999",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.344 67.0064L142.639 71.7902L162.224 60.4294L153.628 55.6455L134.344 67.0064Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.344 92.2725L142.639 97.0563L162.224 85.6933L153.628 80.9094L134.344 92.2725Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.389 92.2722L142.687 97.0561L162.271 85.693L153.675 80.9092L134.389 92.2722Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.639 71.7905V97.0564",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.553 55.6455V80.9091L162.214 85.6843V60.4206",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.344 66.9231V92.1889",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.242 57.5967L126.54 62.3806L146.124 51.0197L137.529 46.2358L118.242 57.5967Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.242 82.8623L126.54 87.6462L146.124 76.2831L137.529 71.4993L118.242 82.8623Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.291 82.8621L126.587 87.6459L146.171 76.2829L137.575 71.499L118.291 82.8621Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.541 62.3809V87.6467",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.451 46.2358V71.4995L146.115 76.2746V51.0109",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M118.242 57.5134V82.7793",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M100.725 46.8377L109.02 51.6215L128.605 40.2585L120.009 35.4746L100.725 46.8377Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100.725 72.1011L109.02 76.885L128.605 65.5241L120.009 60.7402L100.725 72.1011Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100.77 72.1011L109.067 76.885L128.652 65.5241L120.056 60.7402L100.77 72.1011Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M109.021 51.6216V76.8852",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M119.934 35.4746V60.7404L128.595 65.5155V40.2519",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M100.725 46.7544V72.018",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6289 37.6182L92.9268 42.4021L112.511 31.0412L103.915 26.2573L84.6289 37.6182Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6289 62.8838L92.9268 67.6677L112.511 56.3068L103.915 51.5229L84.6289 62.8838Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6777 62.8838L92.9756 67.6677L112.558 56.3068L103.962 51.5229L84.6777 62.8838Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9277 42.4023V67.6682",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.84 26.2573V51.5231L112.501 56.2983V31.0324",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6289 37.5371V62.8007",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M213.331 98.0896L205.034 102.873L185.449 91.5104L194.045 86.7266L213.331 98.0896Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M213.331 123.353L205.034 128.137L185.449 116.776L194.045 111.992L213.331 123.353Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M213.284 123.353L204.989 128.137L185.404 116.776L194 111.992L213.284 123.353Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M205.035 102.873V128.137",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M194.122 86.7266V111.992L185.459 116.768V91.5039",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M213.332 98.0063V123.27",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.969 158.831L256.602 174.034L194.363 137.926L221.683 122.723L282.969 158.831Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.816 107.425L188.52 112.209L168.936 100.846L177.531 96.0623L196.816 107.425Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.816 132.689L188.52 137.473L168.936 126.112L177.531 121.328L196.816 132.689Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.769 132.689L188.471 137.473L168.887 126.112L177.482 121.328L196.769 132.689Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.52 112.209V137.473",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.607 96.0623V121.328L168.945 126.103V100.837",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.814 107.342V132.606",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M266.232 110.722L257.934 115.506L238.35 104.143L246.947 99.3594L266.232 110.722Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M266.232 135.986L257.934 140.77L238.35 129.409L246.947 124.625L266.232 135.986Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M266.185 135.986L257.889 140.77L238.305 129.409L246.9 124.625L266.185 135.986Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M257.936 115.506V140.77",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M247.023 99.3594V124.625L238.359 129.4V104.134",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M266.232 110.639V135.903",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.941 124.976L283.643 129.759L264.059 118.399L272.656 113.615L291.941 124.976Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.941 150.242L283.643 155.026L264.059 143.663L272.656 138.879L291.941 150.242Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.894 150.242L283.598 155.026L264.014 143.663L272.609 138.879L291.894 150.242Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.645 129.76V155.026",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.732 113.615V138.878L264.068 143.653V118.39",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.941 124.893V150.158",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M220.076 93.6343L228.374 98.4182L247.956 87.0573L239.361 82.2734L220.076 93.6343Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M220.076 118.9L228.374 123.684L247.956 112.321L239.361 107.537L220.076 118.9Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M220.121 118.9L228.419 123.684L248.003 112.321L239.408 107.537L220.121 118.9Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M228.373 98.4185V123.684",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M239.285 82.2734V107.537L247.949 112.312V87.0485",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M220.076 93.551V118.817",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.818 82.2517L210.116 87.0356L229.701 75.6725L221.103 70.8887L201.818 82.2517Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.818 107.515L210.116 112.299L229.701 100.938L221.103 96.1543L201.818 107.515Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.867 107.515L210.163 112.299L229.747 100.938L221.152 96.1543L201.867 107.515Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.027 70.8887V96.1545L229.691 100.93V75.666",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.818 107.432V82.1685L210.116 87.0355V112.299",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.32 159.854L229.618 164.637L249.202 153.277L240.607 148.493L221.32 159.854Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.32 185.119L229.618 189.903L249.202 178.54L240.607 173.756L221.32 185.119Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.369 185.119L229.665 189.903L249.249 178.54L240.653 173.756L221.369 185.119Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.619 164.638V189.904",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.529 148.493V173.756L249.193 178.531V153.268",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.32 159.77V185.036",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M205.035 148.522L213.333 153.306L232.917 141.943L224.32 137.159L205.035 148.522Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M205.035 173.786L213.333 178.57L232.917 167.209L224.32 162.425L205.035 173.786Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M205.084 173.786L213.38 178.57L232.964 167.209L224.368 162.425L205.084 173.786Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M213.334 153.306V178.57",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M224.244 137.159V162.425L232.908 167.2V141.936",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M205.035 148.439V173.703",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M402.9 85.2847L394.604 90.0686L375.02 78.7077L383.615 73.9238L402.9 85.2847Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M402.9 110.551L394.604 115.334L375.02 103.971L383.615 99.1875L402.9 110.551Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M402.853 110.551L394.555 115.335L374.971 103.972L383.569 99.1877L402.853 110.551Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M394.604 90.0688V115.335",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M383.689 73.9238V99.1875L375.027 103.963V78.6989",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M402.898 85.2017V110.467",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.889 95.558L354.522 110.761L292.283 74.6535L319.603 59.4502L380.889 95.558Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.894 95.1221L380.596 99.906L361.012 88.5451L369.607 83.7612L388.894 95.1221Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.845 120.387L380.549 125.171L360.965 113.808L369.56 109.024L388.845 120.387Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.596 99.9058V125.172",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.685 83.7612V109.025L361.021 113.8V88.5363",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.895 95.0386V120.304",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M364.154 47.4495L355.856 52.2333L336.271 40.8703L344.869 36.0864L364.154 47.4495Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M364.154 72.7129L355.856 77.4968L336.271 66.1359L344.869 61.3521L364.154 72.7129Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M364.107 72.7129L355.811 77.4968L336.227 66.1359L344.822 61.3521L364.107 72.7129Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M355.857 52.2329V77.4965",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M344.945 36.0864V61.3523L336.281 66.1274V40.8637",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M364.154 47.3662V72.6298",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.863 61.7022L381.565 66.486L361.98 55.1252L370.576 50.3413L389.863 61.7022Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.863 86.9675L381.565 91.7514L361.98 80.3884L370.576 75.6045L389.863 86.9675Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.816 86.9678L381.52 91.7517L361.936 80.3886L370.531 75.6047L389.816 86.9678Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.566 66.4858V91.7517",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.654 50.3413V75.6049L361.99 80.3822V55.1164",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.863 61.6191V86.885",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M318 30.3609L326.296 35.1447L345.88 23.7839L337.284 19L318 30.3609Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M318 55.6265L326.296 60.4103L345.88 49.0473L337.284 44.2634L318 55.6265Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M318.045 55.6262L326.343 60.4101L345.927 49.0471L337.331 44.2632L318.045 55.6262Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M326.297 35.145V60.4108",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M337.209 19V44.2636L345.87 49.0409V23.7751",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M318 30.2771V55.5429",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.434 75.2219L294.729 80.0058L314.314 68.6428L305.718 63.8589L286.434 75.2219Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.434 100.485L294.729 105.269L314.314 93.9084L305.718 89.1245L286.434 100.485Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.479 100.485L294.776 105.269L314.361 93.9084L305.765 89.1245L286.479 100.485Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.643 63.8589V89.1247L314.306 93.8998V68.6362",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.434 100.402V75.1387L294.729 80.0057V105.269",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.244 96.5796L327.542 101.363L347.126 90.0026L338.529 85.2188L319.244 96.5796Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.244 121.846L327.542 126.63L347.126 115.267L338.529 110.483L319.244 121.846Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.293 121.845L327.589 126.629L347.173 115.266L338.577 110.482L319.293 121.845Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.541 101.364V126.63",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.453 85.2188V110.482L347.117 115.26V89.9939",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.244 96.4963V121.762",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M302.957 85.2495L311.255 90.0334L330.837 78.6725L322.241 73.8887L302.957 85.2495Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M302.957 110.513L311.255 115.297L330.837 103.936L322.241 99.1519L302.957 110.513Z",
    stroke: "#231F20",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M303.006 110.513L311.302 115.297L330.886 103.936L322.29 99.1519L303.006 110.513Z",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M311.256 90.0332V115.297",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M322.166 73.8887V99.1523L330.83 103.927V78.6638",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M302.957 85.1663V110.43",
    stroke: "white",
    strokeWidth: 0.501376,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.ad7ea45add9eee1b2dc7cf4c5d54c440.svg";
export { ForwardRef as ReactComponent };